import React from 'react';
import { usePartner } from '@contexts/PartnerContext';
import CustomDateRange from './custom-date-range';
import DailyChart from './DailyChart';
import MonthlyChart from './MonthlyChart';
import WeeklyChart from './WeeklyChart';
import YearlyChart from './YearlyChart';

const SharedWithNOK = () => {
  const { selectedPartnerId } = usePartner();
  return (
    <div>
      <h2 className="govuk-heading-m title">Shared With Next Of Kin</h2>
      <DailyChart partnerCarehomeId={selectedPartnerId || ''} />
      <WeeklyChart partnerCarehomeId={selectedPartnerId || ''} />
      <MonthlyChart partnerCarehomeId={selectedPartnerId || ''} />
      <YearlyChart partnerCarehomeId={selectedPartnerId || ''} />
      <CustomDateRange />
    </div>
  );
};

export default SharedWithNOK;
